import { APP_ENV } from './constants';

export const FALLBACK_CID =
  APP_ENV === 'qa'
    ? '0b64bf3e-cb25-4140-b132-17de8008899a'
    : '9dbef46d-8671-4307-abf8-283b2738170c';
